/**
 * configurator API
 * configurator API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import {FieldTableDto} from './fieldTableDto';


export interface TableDto {
    anonymizable?: boolean;
    anonymizationAction?: TableDto.AnonymizationActionEnum;
    code?: string;
    description?: string;
    fields?: Array<FieldTableDto>;
    id?: string;
    importAutorise?: boolean;
    label?: string;
    labels?: { [key: string]: string; };
    versioning?: boolean;
    partnersIdAcess?: Array<string>;
    ownerPartner?: string;
    schema?: string;
}
export namespace TableDto {
    export type AnonymizationActionEnum = 'REPLACE' | 'DELETE';
    export const AnonymizationActionEnum = {
        REPLACE: 'REPLACE' as AnonymizationActionEnum,
        DELETE: 'DELETE' as AnonymizationActionEnum
    };
}
